import React, {useState, createRef} from 'react';
import {Box, Select, FormControl, CheckIcon} from 'native-base';

import Dropzone, {DropzoneRef} from 'react-dropzone';
import IDropDownOption from '../../../interfaces/ui/dropdown-option.interface';
import {defaultProps} from '../constants';
import {message as t} from '../../../utils/messages';
import {isWebApp} from '../../../utils/platform/is-web';
import {IFileForm} from '../../../interfaces/forms';

interface DropDownInputProps {
  label: string;
  options: IDropDownOption[];
  onChange: (value: any, file: IFileForm) => void;
  isRequired?: boolean;
}

const FileDropDown = (props: DropDownInputProps) => {
  const {label, options, onChange: launchOnChange, isRequired} = props;
  const [selectedValue, setSelectedValue] = useState(null as any);
  const dropzoneRef = createRef<DropzoneRef>();

  React.useEffect(() => {
    if (dropzoneRef && selectedValue) {
      const dropZone = dropzoneRef.current;
      if (dropZone) {
        dropZone.open();
      }
      setSelectedValue(null);
    }
  }, [selectedValue, dropzoneRef]);

  const getMessage = (text: string) => {
    return t(text).trim();
  };

  const defaultMarginWeb = {
    mr: 1,
    ml: 1,
  };

  const getPropertiesWeb = () => {
    if (isWebApp) {
      return defaultMarginWeb;
    }
    return {};
  };

  const parseFilePicked = (asset: File): IFileForm | undefined => {
    return {
      name: asset.name ?? '',
      size: asset.size ?? 0,
      uri: '',
      type: asset.type ?? '',
      content: undefined,
    };
  };

  const handlerOnDrop = (acceptedFiles: File[]) => {
    acceptedFiles.forEach(file => {
      const reader = new FileReader();
      reader.onabort = () => console.debug('file reading was aborted');
      reader.onerror = () => console.debug('file reading has failed');
      reader.onload = () => {
        // Do whatever you want with the file contents
        const contentBase64 = reader.result;
        const result = parseFilePicked(file);
        if (result && result.size > 0) {
          result.content = contentBase64 as string;
          launchOnChange(selectedValue, result);
        } else {
          throw new Error('Fail photo selection');
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const handleOnValueChange = (itemValue: any) => {
    setSelectedValue(itemValue);
  };

  return (
    <Box width="100%" marginBottom={5}>
      <FormControl isRequired={isRequired}>
        <FormControl.Label>{getMessage(label)}</FormControl.Label>
        <Select
          selectedValue=""
          _selectedItem={{
            bg: 'blue.200',
            endIcon: <CheckIcon size="5" color="black" />,
          }}
          mt={1}
          {...defaultProps}
          onValueChange={itemValue => handleOnValueChange(itemValue)}
          fontSize={14}
          {...getPropertiesWeb()}>
          {options.map(option => (
            <Select.Item
              key={option.value}
              label={option.label}
              value={option.value}
            />
          ))}
        </Select>
        <Dropzone
          useFsAccessApi={true}
          onDrop={handlerOnDrop}
          ref={dropzoneRef}>
          {({getRootProps, getInputProps}) => (
            <div {...getRootProps()}>
              <input {...getInputProps()} />
            </div>
          )}
        </Dropzone>
      </FormControl>
    </Box>
  );
};

export default FileDropDown;
